<template lang="pug">
div
  v-card(v-if="edit")
    v-card-title {{ 'Ticket' }} {{ edit.id }} {{ edit.betreff }}
    v-card-text.pt-0
      v-autocomplete(label="Auftraggeber" v-model="edit.userId" :items="[edit.user]" item-text="vollerName" item-value="id" disabled)
      v-layout(wrap)
        v-flex(xs12 sm6): v-select(label="Status" v-model="edit.status" :items="statusOptions" disabled)
        v-flex(xs12 sm6): v-checkbox(label="Freigegeben" v-model="edit.freigabe" disabled)
        v-flex(xs12): tiptap-input(label="Beschreibung" :value="edit.vorgabe && edit.vorgabe.beschreibung" disabled)
        v-flex(xs12): v-textarea(label="Text" v-model="edit.text" :disabled="edit.freigabe === true || edit.status !== 'neu'")
        v-flex(xs12)
          template(v-for="datei in edit.dateien")
            a(target="_blank" :href="datei.original")
              img(:src="datei.thumb" v-if="datei.thumb" :title="datei.name")
              span(v-else)  {{datei.name}}

    v-card-actions
      template(v-if="edit.freigabe")
        v-btn(outline disabled) Ist Bereits Freigegeben
      template(v-else-if="edit.status === 'neu'")
        v-btn(@click="save(true)" color="primary" outline :loading="freigeben === true && loading > 0" :disabled="freigeben === false") Freigeben
        v-btn(@click="save(false)" color="error" outline :loading="freigeben === false && loading > 0" :disabled="freigeben === true") Freigabe Verweigern
      template(v-else)
        v-btn(outline disabled) Ticket ist {{edit.statusHuman}}
  v-card(v-else-if="edit === false || !$route.query.token")
    v-card-text
      v-alert(:value="true" type="error") Konnte nicht gefunden werden.

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      edit: null,
      loading: 0,
      freigeben: null,
      itTickets: [],
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Abgebrochen', value: 'abgebrochen' },
      ],
      headersDetails: [
        { text: 'Anzahl', sortable: false },
        { text: 'Preis', sortable: false },
        { text: 'Artikel', sortable: false },
      ]
    }
  },
  apollo: {
    itTickets: {
      query: gql`query ExtraItTicketFreigabeVueTickets (
        $token: String
      ) {
        itTickets(where: {
          custom: { p: "freigabe_token", v: $token }
        }) {
          id
          status
          statusHuman
          betreff
          text
          freigabe
          userId
          user {
            id
            vollerName
          }
          dateien {
            name
            original
            thumb(size: "100x100")
          }
        }
      }`,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          token: this.$route.query.token,
        }
      },
      skip() {
        return !this.$route.query.token
      }
    }
  },
  watch: {
    itTickets(tickets) {
      const ticket = tickets && tickets[0]
      this.edit = ticket && { ...ticket } || false
    }
  },
  computed: {
    disabled() {
      return !this.edit || this.edit.freigabe || this.edit.status !== 'neu'
    }
  },
  methods: {
    formatEur(value) {
      if (isFinite(value) && !isNaN(value)) {
        return `${(Math.round(value*100)/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`
      } else {
        return ''
      }
    },
    preisForArtikelanzahl(bestellung) {
      const artikel = bestellung.artikel
      const anzahl = artikel.anzahlen.find(([anz, preis]) => bestellung.anzahl === anz)
      if (anzahl) {
        const preis = anzahl[1]
        return preis === 0 ? preis : preis || artikel.preis
      } else {
        return artikel.preis
      }
    },
    save(freigeben) {
      this.freigeben = freigeben
      this.loading++
      this.gqlClearAllErrors()
      const edit = this.edit
      let freigabe = edit.freigabe
      let status = edit.status
      if (freigeben) {
        freigabe = true
      } else {
        status = 'abgebrochen'
      }
      this.$apollo.mutate({
        mutation: gql`mutation (
            $id: ID!,
            $status: String
            $freigabe: Boolean
            $text: String
        ) {
          itTicketUpdate(
            id: $id
            status: $status
            freigabe: $freigabe
            text: $text
          ) {
            id
            status
            freigabe
            text
          }
        }`,
        variables: {
          id: edit.id,
          status: status,
          freigabe: freigabe,
          text: edit.text,
        },
      }).then((data) => {
        this.freigeben = null
        this.loading--
      }, (error) => {
        this.gqlAddErrors(error)
        alert('Ein Fehler is aufgetreten.')
        this.freigeben = null
        this.loading--
      })
    }
  }
}
</script>
